import React, { Component } from 'react'
import { MemberLinkBtnOrangeDark } from '../styles/Elements';
import '../css/BisharatMain.css';
import AuthService from "../services/AuthService";
import Login from '../pages/Login';
import { MdSearch } from 'react-icons/md';



export default class Users extends Component {
    state = {
        allUsers: [],
        search: ''
    }

    componentDidMount() {

        this.refreshUsers();
    }

    refreshUsers = () => {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        if (!loggedInUser || (whatRole === ('USER'))) { } else {
            AuthService.getAllUsers()
                .then(res => {
                    const allUsers = res.data;
                    this.setState({ allUsers });
               
                })
        }
    }


      
    onchangeFind = (event) => {
        this.setState({ search: event.target.value })
      }
      
      filterFunction = (people) => {
        return people.email.indexOf(this.state.search) > -1
      }


      //Details 
      showUser(userName) {
            window.open(`/adminboard/users/${userName}`, '_self');
        }


//Activation and De-activation

        ActivateBish(userName) {
            AuthService.ActivateBish(userName)
            .then((res) => {
                this.refreshUsers();
                window.location.reload();
            })
            .catch((err) => {
            });
        }

        deActivateBish(userName) {
            AuthService.deActivateBish(userName)
            .then((res) => {
                this.refreshUsers();
                window.location.reload();
            })
            .catch((err) => {
            });
        }

        ActivateModerator(userName) {
            AuthService.ActivateModerator(userName)
            .then((res) => {
                this.refreshUsers();
                window.location.reload();
            })
            .catch((err) => {
            });
        }

        deActivateModerator(userName) {
            AuthService.deActivateModerator(userName)
            .then((res) => {
                this.refreshUsers();
                window.location.reload();
            })
            .catch((err) => {
            });
        }






    render() {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        
        return (

            <div className="wrapper-admin-inactive-users">
                { !loggedInUser || (whatRole === ('USER')) ?
                    <div>
                        <Login></Login>
                    </div> :
                    <div className="top-level-page-main users-page-main">
                        <div className="container-view-contents users-page-conents">
                        <div className="list-wrap-contents users-page-wraper">
                        <div className="top-actions users-page">
                        <MemberLinkBtnOrangeDark to='/adminboard/'> Back to Admin Board </MemberLinkBtnOrangeDark>
                        <input
                             type="text" 
                             className="search"
                              name="searchfield" 
                              placeholder="Search Email"
                              value={this.state.search}
                              onChange={this.onchangeFind}
                            />
                              <MdSearch size={40} color="#538D22" />
                          
                          </div>
                        <table className="table-of-users">
                        <tbody>
                        <tr>
                                        <th className="head-table">UserName</th>
                                        <th className="head-table">Email</th>
                                        {/* <th className="head-table">Name</th> */}
                                        {/* <th className="head-table">Active</th> */}
                                        <th className="head-table">Roles</th>
                                        <th className="head-table">Details</th>
                                        <th className="head-table">Control Roles</th>
                                        <th className="head-table">BISH?</th>
                                        </tr>
                            {this.state.allUsers.filter(this.filterFunction).reverse().map(user => (
                               
                                        <tr key={user.id}>
                                        <th>{user.username}</th>
                                        <th>{user.email}</th>
                                        {/* <th>{user.name}</th> */}
                                        {/* {user.allowed ? 
                                        <th className="in-table-activeUser"> ACTIVE</th> :
                                        <th className="in-table-not-activeUser">NOT ACTIVE</th>
                                        } */}
                                       <th>{user.roles.map(role => (role.name === "ROLE_ADMIN" ? "| Admin |" : 
                                           role.name === "ROLE_MODERATOR" ? "| Moderator |" : 
                                           role.name === "ROLE_BISH" ? "| Bish |" :
                                           role.name === "ROLE_USER" ? "| User |" : null
                                       ))}</th>

                                       <th><button className="table-of-users details-btn" onClick={() => this.showUser(user.username)}>Details</button></th>
                                        <th>
                                            <div className="bish-control">
                                            <button   onClick={() => { if (window.confirm('Are you sure you want to add Bish Authentication for this user')) this.ActivateBish(user.username)}} 
                                            className="activate-bish">Bish</button>
                                            <button onClick={() => { if (window.confirm('Are you sure you want to remove Bish Authentication for this user')) this.deActivateBish(user.username)}} 
                                            className="deactivate-bish">Bish</button>
                                            </div>

                                            <div className="moderator-control">
                                            <button onClick={() => { if (window.confirm('Are you sure you want to add Moderator Authentication for this user')) this.ActivateModerator(user.username)}} 
                                            className="activate-moderator">Moderator</button>
                                             <button onClick={() => { if (window.confirm('Are you sure you want to remove Moderator Authentication for this user')) this.deActivateModerator(user.username)}} 
                                            className="deactivate-moderator">Moderator</button>
                                           </div>
                                        </th>
                                        <th>{user.requestPermission ? "Yes" : "--"}</th>
                                    </tr>
                            ))}
                             
                            </tbody>
                             </table>
                            </div>
                        </div>
                     
                    </div>
                }</div>

        )

    }
}
